<!-- Main page layout handling. -->
<div class="main-content">
  <!-- Super-admin toolbar (only for super admins, non-widget routes) -->
  <app-super-admin-menu *ngIf="!isWidgetRoute && permissions.isSuperAdmin()"></app-super-admin-menu>

  <!-- Site-wide incident banner (all users see it when enabled) -->
  <app-incident-banner *ngIf="!isWidgetRoute"></app-incident-banner>

  <!-- Only show menu for non-widget routes -->
  <app-menu *ngIf="!isWidgetRoute"></app-menu>

  <!-- Holiday Memorial Day Banner (only for non-widget routes) -->
  <!-- <app-holiday-notification
    *ngIf="!isWidgetRoute"
    [visible]="holidayService.notificationVisible$ | async"
    [title]="holidayService.getHolidayTitle()"
    [message]="holidayService.getHolidayMessage()"
    (close)="holidayService.hideNotification()">
  </app-holiday-notification> -->

  <!-- Router View -->
  <div class="router-content">
    <router-outlet></router-outlet>
  </div>

  <!-- Version notification (only for non-widget routes) -->
  <app-version-notification
    *ngIf="!isWidgetRoute"
    [visible]="versionService.notificationVisible$ | async"
    [currentVersion]="versionService.getCurrentVersion()"
    [latestVersion]="versionService.getServerVersion()"
    (refresh)="versionService.refreshPage()"
    (close)="versionService.hideVersionMismatchNotification()">
  </app-version-notification>
</div>

<!-- Footer (only for non-widget routes) -->
<app-footer *ngIf="!isWidgetRoute"></app-footer>
